import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import cx from 'classnames';
import useWindowPosition from '@/utils/useWindowPosition';
import { navLinks } from '@/data/navLinks';
import Image from 'next/image';
import { NavLink } from '@/data/navLinks';

export default function Navbar() {
  const [showNav, setShowNav] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [scrollY, setScrollY] = useState(0);
  const position = useWindowPosition();

  useEffect(() => {
    if (position < scrollPosition) {
      setShowNav(true);
    } else if (position > 100) {
      setShowNav(false);
    }
    setScrollPosition(position);
  }, [position, scrollPosition]);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const whiteLogo = '/images/logo.png';
  const darkLogo = '/images/logoWhite.png';

  return (
    <nav
      className={cx({
        'fixed top-0 z-50 w-full transition-all duration-300': true,
        'bg-white/95 dark:bg-dark-background/95 shadow-lg backdrop-blur-sm': scrollY >= 75,
        'bg-transparent': scrollY < 75,
        'translate-y-0': showNav || scrollY < 75,
        '-translate-y-full': !showNav && scrollY >= 75,
      })}
    >
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <div className="flex-shrink-0">
            <Link href={NavLink.HOME}>
              <Image
                src={scrollY >= 75 ? whiteLogo : darkLogo}
                width={120}
                height={93}
                alt="pcollins.tech"
                className="w-auto h-12"
              />
            </Link>
          </div>

          <div className="hidden sm:flex sm:items-center sm:space-x-8">
            {navLinks.map((link) => (
              <Link
                href={link.route}
                key={link.label}
                className={cx({
                  'text-base font-medium hover:text-pink-500 transition-colors': true,
                  'text-gray-900 dark:text-white': scrollY >= 75,
                  'text-white': scrollY < 75,
                })}
              >
                {link.label}
              </Link>
            ))}
            <Link
              href={NavLink.CONTACT}
              className="group relative inline-flex items-center justify-center px-6 py-2.5 text-base font-medium text-white 
                       bg-gradient-to-r from-pink-500 to-purple-500 rounded-full overflow-hidden transition-all duration-300
                       hover:from-pink-600 hover:to-purple-600 transform hover:-translate-y-1 hover:shadow-xl"
            >
              <span className="relative z-10">
                Start a Project
                <span className="ml-1 inline-block transition-transform duration-300 group-hover:translate-x-1">
                  →
                </span>
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-pink-600/50 to-purple-600/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
